export default () => ({
  S_MASSIVELY_PHOTOS: [],
});
